export default __webpack_public_path__ + "static/media/on-date.1376e87a.svg";